import NotificationActions from 'client/js/main/actions/NotificationActions';
import dash_api from 'client/js/main/support/dash_api';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { Action } from 'redux';
import type { CostFileTemplate } from 'shared/types/roi-hub/fileIngestion.types';

export const SetupCostFileTemplateAction = new ReduxAsyncAction<
  'ROI_COST_FILE_TEMPLATE_SETUP',
  Partial<CostFileTemplate>,
  CostFileTemplate
>('ROI_COST_FILE_TEMPLATE_SETUP');

SetupCostFileTemplateAction.registerRequest(async (payload) => {
  try {
    const { data } = await dash_api.post<CostFileTemplate>('/v1/roi/cost-file-templates', payload);
    NotificationActions.showNotification('Setup complete ', 'success');

    return data;
  } catch (error) {
    NotificationActions.showNotification('Error occurred when setting up cost file template', 'error');
    throw error;
  }
});

export const SETUP_COST_FILE_TEMPLATE_ACTION = SetupCostFileTemplateAction.actionNamespaceConstants;

export const setupCostFileTemplate = SetupCostFileTemplateAction.request;

export type SetupCostFileTemplateResponseAction = Action<typeof SETUP_COST_FILE_TEMPLATE_ACTION.response> & {
  data: CostFileTemplate;
};
